import {Companies, Segments} from "./models.js";

function SegmentItem() {

    // String
    const name = null;
    const description = null;
    const consequence = null;
    const requirement = null;

    // Integer
    const level = 1;
    const xp = 0;
    const minParticipants = 2;
    const maxParticipants = 2;
    const monthsToReuse = 36;  // To check if special segment item is available to use again
    const hypeBoost = 1;
    const popularityBoost = 0;
    const difficulty = 1;
    const entertainment = 1;
    const action = 1;

    // Boolean
    const unlocked = true;
    const standard = false;
    const silly = false;
    const oneAtATime = true;
    const chooseWinner = true;
    const feudOnly = false;
    const oneWayConsequence = false;
    const productionSegment = false;
    const custom = false;
    const temporary = false;
    const saveToCommunity = false;
    const special = false;
    const used = false;  // To check if special segment item as been used
    const factionSegment = false;

    // Foreign keys
    const companyId = null;

    // Objects
    const text = {};

    // Arrays
    const startTexts = [];
    const actionTexts = [];

    return {
        name,
        description,
        consequence,
        requirement,
        level,
        xp,
        minParticipants,
        maxParticipants,
        monthsToReuse,
        hypeBoost,
        popularityBoost,
        difficulty,
        entertainment,
        action,
        unlocked,
        standard,
        silly,
        oneAtATime,
        chooseWinner,
        feudOnly,
        oneWayConsequence,
        productionSegment,
        custom,
        temporary,
        saveToCommunity,
        special,
        used,
        factionSegment,
        companyId,
        text,
        startTexts,
        actionTexts,
    };
}

function getSegmentItemSegments(segmentItem) {
    return Segments.find({'segmentItemId': segmentItem.$loki});
}

function addSegmentItemSegments(segmentItem, segments) {
    segments.forEach(c => {
        c.segmentItemId = segmentItem.$loki
    });
}

function removeSegmentItemSegments(segmentItem, segments) {
    segments.forEach(c => {
        c.segmentItemId = null
    });
}

function getSegmentItemCompany(segmentItem) {
    return Companies.find({'$loki': segmentItem.companyId})[0];
}


export { SegmentItem, addSegmentItemSegments, removeSegmentItemSegments, getSegmentItemSegments, getSegmentItemCompany }
